import { JsonConverter } from '../JsonConverter'
import { PreguntaSecundaria } from 'app/dominio/pregunta-secundaria'

export class RespuestaPrimerNivel implements JsonConverter {
  
  private _id: string
  private _texto: string
  private _textoAbierto: string
  private _indice: number
  private _noAsegurable: boolean
  private _preguntasSecundarias: PreguntaSecundaria[]
  private _autoCompletarVacio: boolean
  private _idSiguiente: string
  private _finalizada: boolean
  private _seleccionada: boolean
  
  constructor(
    id: string,
    texto: string,
    textoAbierto: string,
    indice: number,
    noAsegurable: boolean,
    preguntasSecundarias: PreguntaSecundaria[],
    idSiguiente: string = null,
    finalizada: boolean = false,
    seleccionada: boolean = false
  ) {
    this._id = id
    this._texto = texto
    this._textoAbierto = textoAbierto
    this._indice = indice
    this._noAsegurable = noAsegurable
    this._preguntasSecundarias = preguntasSecundarias
    this._autoCompletarVacio = false
    this._idSiguiente = idSiguiente
    this._finalizada = finalizada
    this._seleccionada = seleccionada
  }

  set agregarPs(ps: PreguntaSecundaria) {
    this._preguntasSecundarias.push(ps)
  }
  
  get id(): string {
    return this._id
  }

  get texto(): string {
    return this._texto
  }

  get textoAbierto(): string {
    return this._textoAbierto
  }

  set textoAbierto(texto) {
    this._textoAbierto = texto
  }

  get indice(): number {
    return this._indice
  }

  get noAsegurable(): boolean{
    return this._noAsegurable
  }

  get preguntasSecundarias(): PreguntaSecundaria[] {
    return this._preguntasSecundarias
  }

  get autocompletarVacio(): boolean {
    return this._autoCompletarVacio
  }

  // FIXME: @andratco esto no se deeb poder asignar, sino que debe ser calculado.
  set autocompletarVacio(valor) {
    this._autoCompletarVacio = valor
  }

  get idSiguiente(): string {
    return this._idSiguiente
  }

  get finalizada(): boolean {
    return this._finalizada
  }

  set finalizada(f: boolean) {
    this._finalizada = f
  }

  get seleccionada(): boolean {
    return this._seleccionada
  }

  set seleccionada(valor: boolean) {
    this._seleccionada = valor
  }

  set preguntasSecundarias(preguntasSecundarias) {
    this._preguntasSecundarias = preguntasSecundarias 
  }
  
  toJson(): any {
    return {
      id: this.id,
      texto: this.texto,
      textoAbierto: this.textoAbierto,
      indice: this.indice,
      noAsegurable: this.noAsegurable,
      idSiguiente: this.idSiguiente
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dominio/respuesta-primer-nivel.ts